import * as React from 'react';

import { cn } from '../lib/utils';

const Input = React.forwardRef(({ className, type = 'text', ...props }, ref) => (
  <input
    ref={ref}
    type={type}
    className={cn(
      // `border-input` is the darker control outline, not the decorative border:
      // the outline is what identifies the field, so it has to carry 3:1.
      'flex h-9 w-full rounded-md border-hairline border-input bg-card px-3 py-1 text-sm text-foreground transition-colors',
      'file:border-0 file:bg-transparent file:text-sm file:font-medium',
      'placeholder:text-muted-foreground',
      'hover:border-primary/50',
      'focus-visible:outline-none focus-visible:border-primary focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-0',
      'disabled:cursor-not-allowed disabled:bg-secondary disabled:text-subtle-foreground',
      'aria-[invalid=true]:border-destructive aria-[invalid=true]:focus-visible:ring-destructive',
      className,
    )}
    {...props}
  />
));
Input.displayName = 'Input';

export { Input };
